import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CodebaseTranslateService } from '@app/services/codebase-translate.service';
import { QrCodeComponent } from '@app/shared/qr-code/qr-code.component';
import { ModalController } from '@ionic/angular';
import { environment } from '@env/environment';

@Component({
  selector: 'app-modal-success-reservation',
  templateUrl: './modal-success-reservation.component.html',
  styleUrls: ['./modal-success-reservation.component.scss'],
})
export class ModalSuccessReservationComponent implements OnInit {
  title: string;
  @Input() reservation: any;
  public environment = environment;
  constructor(
    private router: Router,
    public translate: CodebaseTranslateService,
    private modalCtrlr: ModalController,) { }

  ngOnInit() {}

  goToKey(){
    this.router.navigate(["/tabs/qr-code"]);
  }

  goBack(){
    this.modalCtrlr.dismiss();
  }

  back(){
    this.modalCtrlr.dismiss();
    this.router.navigate(["/tabs/home"]);
  }

  async showIframeQR() {
    this.modalCtrlr.dismiss();
    let translates = {
      LBL_CHECKOUTTITLE: this.translate.instant("CHECKIN.MODAL_QRCODE.LBL_CHECKOUTTITLE"),
      LBL_CHECKOUT: this.translate.instant("CHECKIN.MODAL_QRCODE.LBL_CHECKOUT"),
      LBL_PLEASEGOTOKIOSK: this.translate.instant("CHECKIN.MODAL_QRCODE.LBL_PLEASEGOTOKIOSK"),
      LBL_SCANTHECODE: this.translate.instant("CHECKIN.MODAL_QRCODE.LBL_SCANTHECODE"),
      BTN_CREATEKEY: this.translate.instant("CHECKIN.MODAL_QRCODE.BTN_CREATEKEY"),
      BTN_WHEREISMYROOM: this.translate.instant("CHECKIN.MODAL_QRCODE.BTN_WHEREISMYROOM"),
      BTN_ROOMMANAGER: this.translate.instant("CHECKIN.MODAL_QRCODE.BTN_ROOMMANAGER"),
    };
    this.router.navigate(["/welcome-checkin/qr-checkin"]);
    const modal = await this.modalCtrlr.create({
      component: QrCodeComponent,
      cssClass: 'qr-modal',
      componentProps: {
        reservation: this.reservation,
        url: "https://hotelnext.com/en/home/",
        translates:translates
      },
    });
    // await modal.present();
  }

}
